import React, { Component } from 'react'
import { Row, Col, Table, Button, Select, Spin, Cascader, Modal, Input } from 'antd'
import { app, api, config } from "../../app"
import '../../css/expert.css'
import Head from "../../components/Head"
import Iconz from "../../components/Iconz"
import utils from "../../utils"
import EMEdit from "./EMEdit"
import EMDetail from "./EMDetail"

const Option = Select.Option
const Search = Input.Search

class EMList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data_loading: false,
            posi_loading: true,
            ppe_loading: true,
            dataList: [],
            positionalList: [],
            ppeList: [{ names: '全部', id: '0' }],
            positional_id: '0',
            ppe_class_id: '0',
            search_key: '',
            edit_id: null,
            edit_modal: false,
            detail_loading: false,
            detail_modal: false,
            expert_info: {},
            total: 0,
            page: 1,
        }
    }

    componentDidMount() {
        if (!app.getToken() || app.getData('rights') !== 1) {
            this.props.history.replace('/')
        }
        this._isMounted = true
        this.positionalSource()
        this.ppeSource()
        this.dataSource(1)
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 列表数据
     * @param page
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        const { positional_id, ppe_class_id, search_key } = this.state, params = {
            page,
            positional_id,
            ppe_class_id,
            search: search_key,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.EAdminLists, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page) {
            this.setData({ data_loading: false, dataList: utils.addArrayKey(data), total: parseInt(total || 0) })
        }
    }

    /**
     * 职称数据
     */
    positionalSource = async () => {
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.EPositionalSelectLists, params)
        const state = { posi_loading: false }
        if (flag === 1) {
            state.positionalList = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 技能数据
     */
    ppeSource = async () => {
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            parent: 1
        }
        let { flag, data, msg } = await app.post(api.PpeClass, params)
        const state = { ppe_loading: false }
        if (flag === 1) {
            state.ppeList = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 详情数据
     */
    detailSource = async (id) => {
        const params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.EAdminDetail, params)
        const state = { detail_loading: false }
        if (flag === 1) {
            state.expert_info = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 打开编辑框
     * @param edit_id
     */
    handleOpenEditModal = async (edit_id) => {
        if (edit_id) {
            await this.setData({ edit_modal: true, edit_id, detail_loading: true })
            await this.detailSource(edit_id)
        } else {
            await this.setData({ edit_modal: true })
        }
    }

    /**
     * 打开详情框
     * @param id
     */
    handleOpenDetailModal = async (id) => {
        await this.setData({ detail_modal: true, detail_loading: true })
        await this.detailSource(id)
    }

    /**
     * 关闭编辑框
     */
    handleCloseEditModal = () => {
        this.setData({ edit_modal: false, edit_id: null, expert_info: {} })
    }

    /**
     * 关闭详情框
     */
    handleCloseDetailModal = () => {
        this.setData({ detail_modal: false, expert_info: {} })
    }

    /**
     * 编辑成功
     * @param values
     * @param id
     */
    handleEditSuccess = async (values, id) => {
        values.account = app.getData('account')
        values.indexno = app.getData('indexno')
        if (id) {
            values.id = id
            let { flag, msg } = await app.post(api.EAdminEdit, values)
            if (flag === 1) {
                app.alert('修改成功', 'success')
                await this.handleCloseEditModal()
                this.dataSource(this.state.page)
                return true
            } else {
                app.alert(msg, 'error')
            }
        } else {
            let { flag, msg } = await app.post(api.EAdminAdd, values)
            if (flag === 1) {
                app.alert('添加成功', 'success')
                await this.handleCloseEditModal()
                this.dataSource(this.state.page)
                return true
            } else {
                app.alert(msg, 'error')
            }
        }
        return false
    }

    /**
     * 解聘/聘用
     * @param id
     * @returns {Promise<void>}
     */
    handleRelieve = async (id) => {
        app.alert('正在加载', 'loading', '35%', 0)
        const params = {
            id,
            account: app.getData('account'),
            indexno: app.getData('indexno'),
        }
        let { flag, msg } = await app.post(api.EAdminRelieve, params)
        app.alertDestroy()
        if (flag === 1) {
            app.alert('设置成功', 'success')
            await this.dataSource(this.state.page)
        } else {
            app.alert(msg, 'error')
        }

    }

    render() {
        let {
            dataList, positionalList, ppeList, data_loading, posi_loading, ppe_loading, edit_id, expert_info, edit_modal,
            detail_modal, detail_loading, total, page
        } = this.state,
            columns = [
                {
                    title: '头像',
                    dataIndex: 'head_img',
                    key: 'head_img',
                    width: '15%',
                    render: (img) => {
                        return (
                            <div style={{ width: 140, height: 104 }}>
                                <img style={{
                                    maxWidth: '100%',
                                    width: 'auto',
                                    height: 'auto',
                                    maxHeight: '100%'
                                }} src={config.imgUrl + img} alt="头像" />
                            </div>
                        )
                    }

                },
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width: '15%',
                },
                {
                    title: '职称类别',
                    dataIndex: 'positional',
                    key: 'positional',
                    width: '15%'
                },
                {
                    title: '专职课程',
                    dataIndex: 'ppe',
                    key: 'ppe',
                    width: '15%',
                    render: (ppe) => ppe.join('、')
                },
                {
                    title: '聘用期限',
                    dataIndex: 'employ_start',
                    key: 'employ_start',
                    width: '25%',
                    render(employ_start, { employ_end }) {
                        return employ_start + ' 至 ' + employ_end
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '15%',
                    render: (id, { flag }) => {
                        return (
                            <div>
                                <div>
                                    {
                                        flag === '1' ? (
                                            <Button type="danger" size="small"
                                                onClick={() => this.handleRelieve(id)}>解聘</Button>
                                        ) : (
                                            <Button type="primary" size="small"
                                                onClick={() => this.handleRelieve(id)}>聘用</Button>
                                        )
                                    }
                                </div>
                                <div style={{ margin: '.5rem 0' }}><Button type="primary"
                                    onClick={() => this.handleOpenEditModal(id)}
                                    size="small">编辑</Button></div>
                                <div><Button type="primary" onClick={() => this.handleOpenDetailModal(id)}
                                    size="small">详情</Button></div>
                            </div>
                        )
                    }
                },
            ]
        return (
            <div className="expert-page">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48} />
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history} />
                <div className="ep-content">
                    <Row type="flex" justify="space-between" align="middle" className="ep-title" style={{marginBottom:'30px'}}>
                        <Col className="ept-t" style={{ paddingTop: '40px', marginBottom: '40px' }}>存心专家库</Col>
                        <Col><Button type="primary" icon="user-add"
                            onClick={() => this.handleOpenEditModal()}>添加专家</Button></Col>
                    </Row>
                    <Row type="flex" justify="space-between" className="epc-filter">
                        <Col>
                            <span>职称筛选: </span>
                            <Select defaultValue="0" style={{ width: '10rem', fontSize: '.8rem' }}
                                onChange={async (value) => {
                                    await this.setData({ positional_id: value })
                                    await this.dataSource(1)
                                }}
                                notFoundContent={posi_loading ? <Spin size="small" /> : null}
                            >
                                <Option value="0">全部</Option>
                                {
                                    positionalList.map(p => (
                                        <Option key={p.value} value={p.value}>{p.title}</Option>
                                    ))
                                }
                            </Select>
                            <span style={{ marginLeft: '1rem' }}>专职筛选: </span>
                            <Select defaultValue="0" style={{ width: '10rem', fontSize: '.8rem' }}
                                onChange={async (value) => {
                                    await this.setData({ ppe_class_id: value })
                                    await this.dataSource(1)
                                }}
                                notFoundContent={ppe_loading ? <Spin size="small" /> : null}
                            >
                                <Option value="0">全部</Option>
                                {
                                    ppeList.map(p => (
                                        <Option key={p.id} value={p.id}>{p.names}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                        <Col>
                            <Search placeholder="搜索专家" style={{ width: '16rem', fontSize: '.8rem' }}
                                onSearch={async (value) => {
                                    await this.setData({ search_key: value })
                                    await this.dataSource(1)
                                }} />
                        </Col>
                    </Row>
                    <Table columns={columns}
                        locale={app.tbLocale(data_loading)}
                        dataSource={dataList}
                        loading={data_loading}
                        scroll={{ y: 'calc(100vh - calc(7rem + 181px))' }}
                        style={{ height: 'calc(100% - calc(7rem + 78px))' }}
                        pagination={{
                            total,
                            current: page,
                            pageSize: 20,
                            showTotal: (t) => `总记录${t}条`
                        }}
                        className="table-odd-even-row"
                        size="small"
                    />
                </div>
                <Modal
                    visible={edit_modal}
                    footer={null}
                    title={edit_id ? "编辑信息" : '添加专家'}
                    maskClosable={false}
                    width='80%'
                    centered
                    style={{ padding: 0 }}
                    destroyOnClose={true}
                    bodyStyle={{ height: '70vh', overflow: 'auto' }}
                    onCancel={this.handleCloseEditModal}
                >
                    {
                        detail_loading ? (
                            <div style={{ textAlign: 'center' }}><Spin size="large" /></div>
                        ) : (
                            <EMEdit
                                info={edit_id ? expert_info : null}
                                ppes={ppeList}
                                positionals={positionalList}
                                cancel={this.handleCloseEditModal}
                                success={this.handleEditSuccess}
                            />
                        )
                    }
                </Modal>
                <Modal
                    visible={detail_modal}
                    title='详细信息'
                    maskClosable={false}
                    width='80%'
                    centered
                    style={{ padding: 0 }}
                    destroyOnClose={true}
                    bodyStyle={{ height: '70vh', overflow: 'auto' }}
                    footer={
                        <Button type="primary" onClick={() => this.handleCloseDetailModal()}>确定</Button>
                    }
                    onCancel={this.handleCloseDetailModal}
                >
                    {
                        detail_loading ? (
                            <div style={{ textAlign: 'center' }}><Spin size="large" /></div>
                        ) : (<EMDetail info={expert_info} />)
                    }
                </Modal>
            </div>
        )
    }
}

export default EMList



// WEBPACK FOOTER //
// ./src/routes/expert/EMList.jsx